import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Product } from "../../../models/product.model";

@Component({
  selector: "ngx-layout-print-product",
  templateUrl: "layout-print-product.component.html",
  styleUrls: ["layout-print-product.component.scss"],
})
export class LayoutPrintProductComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() product?: Product;
  @Input() coverUrl?: string;

  loading = false;
  printing = false;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.coverUrl = this.coverUrl ? this.coverUrl : "";
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {}

  print() {
    this.printing = true;
  }
}
